import React from 'react'
import { Autocomplete, TextField , Box ,Checkbox} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from '@mui/icons-material/Info';
const FormikMultiple = ({label , 
    fullWidthFlag = false,
    text ='',
    validationOn=false,
    width="480px" ,
     name ,
      formik , 
      Info,
      isOptionEqualToValue = (option, value) => option.name === value?.name,
      ...props  }) => {
  return (

  <>
    <Autocomplete
      size="small"
      fullWidth = {fullWidthFlag}
      disablePortal
      disableClearable={true}     
      multiple
      limitTags={2}
      disableCloseOnSelect
      isOptionEqualToValue={isOptionEqualToValue}
      {...props}
      renderOption={(props, option, { selected }) => (
        <Box
          component="li"
          {...props}
          sx={{ paddingLeft: "0px", marginLeft: "0px" }}
        >
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            sx={{
              height: "28px",
              width: "32px",
            }}
            checked={selected}
          />
          {option.name}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
        size="small"
        variant="outlined"
        placeholder={label}
        label={text}
        {...params}
        sx={{
          marginBottom:"15px",
          ".MuiFormLabel-root": { color: "#50566E" },
          "& .MuiInputBase-root": {
            backgroundColor: "#ffffff",
            borderRadius: "4px",
            color: "#1C2238",
            fontSize: ".875rem",
            fontWeight: 550,
            "& fieldset": {
              borderColor: "#D3D8E3",
            },
            "&:hover fieldset": {
              borderColor: "#D3D8E3",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#D3D8E3",
            },
            
          },
         " .MuiOutlinedInput-input":{
          '&::placeholder': {
              color: "#50566E !important",
              opacity:"1"
            }
         }
         
        }}
          error={validationOn && formik?.errors[name]}
        helperText={validationOn && formik?.errors[name]}
          />)}
    popupIcon={<ExpandMoreIcon size="small" />}
    sx={{
      width: fullWidthFlag ? "inherit" : width,
    }}
    onChange={(_, value) => {      
        if (value || value === 0) {
          formik.setFieldValue(name, value)
       if(!props.touched) props.setTouched(true)
          if (props.setChangeEvent) {
            props.setChangeEvent(value)
          }
        } else formik.setFieldValue(name, '')
      }}
    />
{Info &&  <Box
 sx={{
  color:'#8792AB',
  fontSize:"13px",
  display:"flex",
  alignItems:"center",
  gap:"5px",
  marginBottom:"10px"
 }}
 ><InfoIcon fontSize='10px'/>{Info}</Box>
  }
  </>

  )
}

export default FormikMultiple